module.exports = __webpack_public_path__ + "img/party.e7b75b73.png";